import React, { Component } from 'react';
import $ from 'jquery';

class Navbar extends Component {

	constructor() {
		super()
		this.state = {
			'device': $(window).width() < 1065 ? 'touch' : 'desktop',
		}
		this.handleOnClick = this.handleOnClick.bind(this)
	}

	detectDevice() {
		this.setState({
			'device': $(window).width() < 1065 ? 'touch' : 'desktop'
		})
	}
	
	componentWillMount() {
		window.addEventListener("resize", this.detectDevice.bind(this))
	}

	handleBurgerClick() {
		var isBlack = $('#navbar-container').hasClass('has-background-black')
		if(isBlack)
		{
			$('#navbar-container').removeClass('has-background-black')
			$('#navMenu div.navbar-end').children().each(function() {
				$(this).removeClass('has-text-white')
				$(this).addClass('has-text-black')
			})
	
			$('div.navbar-brand a').removeClass('has-text-white')
			$('div.navbar-brand a').addClass('has-text-black')
		}
		else
		{
			$('#navbar-container').addClass('has-background-black')
			$('#navMenu div.navbar-end').children().each(function() {
				$(this).removeClass('has-text-black')
				$(this).addClass('has-text-white')
			})
	
			$('div.navbar-brand a').removeClass('has-text-black')
			$('div.navbar-brand a').addClass('has-text-white')
		}
	}

	handleOnClick(e) {
		e.preventDefault();
		var target = e.target;

		// get element and scroll the element into view
		var el = document.getElementById(target.text.toLowerCase())
		el.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"})

		// close the navbar list
		if(this.state === 'touch')
		{
			var navMenu = document.getElementById('navMenu')
			var activeMenuItem = document.getElementsByClassName("navbar-burger burger")
			navMenu.classList.remove("is-active")
			activeMenuItem[0].classList.remove("is-active")
		}
	}

	render() {
		return(
		<div id="navbar-container" className="column">
			<nav className="navbar">
				<div className="container">
					<div className="navbar-brand">
					 	<a href="" className="navbar-item has-text-black has-text-weight-bold is-heading is-size-6-mobile is-size-5-tablet is-size-4-desktop animated fadeInDown delay-2s">
							Akshay Patel
						</a> 
						<span id="burgerButton" className="navbar-burger burger animated fadeInDown delay-2s" data-target="navMenu" onClick={(e) => this.handleBurgerClick(e)}>
							<span></span>
							<span></span>
							<span></span>
						</span>
					</div>
					<div id="navMenu" className="navbar-menu navMenuBackground animated fadeInDown delay-2s">
						<div className="navbar-end">
							<a className="navbar-item has-text-black" href="" onClick={(e) => this.handleOnClick(e)}>
								Home
							</a>
							<a className="navbar-item has-text-black" href="" onClick={(e) => this.handleOnClick(e)}>
								About
							</a>
							<a className="navbar-item has-text-black" href="" onClick={(e) => this.handleOnClick(e)}>
								Timeline
							</a>
							<a className="navbar-item has-text-black" href="" onClick={(e) => this.handleOnClick(e)}>
								Projects
							</a>
							<a className="navbar-item has-text-black" href="" onClick={(e) => this.handleOnClick(e)}>
								Skills
							</a>
							<a className="navbar-item has-text-black" href="" onClick={(e) => this.handleOnClick(e)}>
								Contact
							</a>
						</div>
					</div>
				</div>
			</nav> 
		</div>
		)
	}
}

export default Navbar;